/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersistentNotificationImpactSeverity } from './PersistentNotificationImpactSeverity';
import {
    PersistentNotificationImpactSeverityFromJSON,
    PersistentNotificationImpactSeverityFromJSONTyped,
    PersistentNotificationImpactSeverityToJSON,
    PersistentNotificationImpactSeverityToJSONTyped,
} from './PersistentNotificationImpactSeverity';
import type { PersistentNotificationType } from './PersistentNotificationType';
import {
    PersistentNotificationTypeFromJSON,
    PersistentNotificationTypeFromJSONTyped,
    PersistentNotificationTypeToJSON,
    PersistentNotificationTypeToJSONTyped,
} from './PersistentNotificationType';

/**
 * 
 * @export
 * @interface PersistentNotification
 */
export interface PersistentNotification {
    /**
     * 
     * @type {string}
     * @memberof PersistentNotification
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PersistentNotification
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersistentNotification
     */
    updatedAt: Date;
    /**
     * 
     * @type {PersistentNotificationType}
     * @memberof PersistentNotification
     */
    notificationType: PersistentNotificationType;
    /**
     * 
     * @type {Date}
     * @memberof PersistentNotification
     */
    triggeredAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentNotification
     */
    read: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistentNotification
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof PersistentNotification
     */
    fleetUserId?: string | null;
    /**
     * 
     * @type {PersistentNotificationImpactSeverity}
     * @memberof PersistentNotification
     */
    impactSeverity?: PersistentNotificationImpactSeverity | null;
    /**
     * 
     * @type {number}
     * @memberof PersistentNotification
     */
    hoursUntilMaintenance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PersistentNotification
     */
    truckDepartmentId?: string | null;
}



/**
 * Check if a given object implements the PersistentNotification interface.
 */
export function instanceOfPersistentNotification(value: object): value is PersistentNotification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('triggeredAt' in value) || value['triggeredAt'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    return true;
}

export function PersistentNotificationFromJSON(json: any): PersistentNotification {
    return PersistentNotificationFromJSONTyped(json, false);
}

export function PersistentNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersistentNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'notificationType': PersistentNotificationTypeFromJSON(json['notificationType']),
        'triggeredAt': (new Date(json['triggeredAt'])),
        'read': json['read'],
        'vehicleId': json['vehicleId'],
        'fleetUserId': json['fleetUserId'] == null ? undefined : json['fleetUserId'],
        'impactSeverity': json['impactSeverity'] == null ? undefined : PersistentNotificationImpactSeverityFromJSON(json['impactSeverity']),
        'hoursUntilMaintenance': json['hoursUntilMaintenance'] == null ? undefined : json['hoursUntilMaintenance'],
        'truckDepartmentId': json['truckDepartmentId'] == null ? undefined : json['truckDepartmentId'],
    };
}

export function PersistentNotificationToJSON(json: any): PersistentNotification {
    return PersistentNotificationToJSONTyped(json, false);
}

export function PersistentNotificationToJSONTyped(value?: PersistentNotification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'notificationType': PersistentNotificationTypeToJSON(value['notificationType']),
        'triggeredAt': value['triggeredAt'].toISOString(),
        'read': value['read'],
        'vehicleId': value['vehicleId'],
        'fleetUserId': value['fleetUserId'],
        'impactSeverity': PersistentNotificationImpactSeverityToJSON(value['impactSeverity']),
        'hoursUntilMaintenance': value['hoursUntilMaintenance'],
        'truckDepartmentId': value['truckDepartmentId'],
    };
}

